import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {get} from 'lodash';
import translate from '../../utils/translations';
import {EmailConfirmation} from '../EmailConfirmation/EmailConfirmation';
import LoadingErrorDisplay from '../LoadingErrorDisplay/LoadingErrorDisplay';

import './LoadingError.less';

export class LoadingError extends PureComponent {
    static propTypes = {
        emptyLabel: PropTypes.string,
        error: PropTypes.shape({}),
        systemData: PropTypes.shape({}),
        translations: PropTypes.shape({}),
    };

    static defaultProps = {
        error: {},
        systemData: {},
        translations: {},
    };

    render() {
        const {error, systemData, translations} = this.props;
        const errorMessage = get(error, 'message', '');
        const isUnconfirmedUser =
            errorMessage.indexOf('409') > -1 ||
            error?.networkError?.statusCode === 409;
        const isTravelerNotAllowed =
            errorMessage.indexOf('403') > -1 ||
            error?.networkError?.statusCode === 403;
        const classes = classNames(this.props.className, 'LoadingError');

        if (isUnconfirmedUser) {
            return (
                <div className={classes}>
                    <EmailConfirmation
                        systemData={systemData}
                        translations={translations}
                    />
                </div>
            );
        }

        return (
            <div className={classes}>
                {isTravelerNotAllowed ? (
                    <LoadingErrorDisplay
                        ctaLabel={translate(
                            translations,
                            'trav-dash/trav-home',
                            'nav',
                            'th.header.logout'
                        )}
                        ctaLink={'/auth/ui/logout'}
                        message={translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.inbox.unknown.traveler.error.message'
                        )}
                        title={translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.inbox.unknown.traveler.error.title'
                        )}
                    />
                ) : (
                    <LoadingErrorDisplay
                        ctaLabel={translate(
                            translations,
                            'trav-dash/trav-home',
                            'messages',
                            'th.inbox.empty.link'
                        )}
                        ctaLink={'/search'}
                        message={
                            this.props.emptyLabel ||
                            translate(
                                translations,
                                'trav-dash/trav-home',
                                'messages',
                                'th.bookings.empty.message'
                            )
                        }
                    />
                )}
            </div>
        );
    }
}
